import { post } from '@cash-web/shared-util-fetch'
import { LogoutResponse } from '@cash-web/shared-util-protos/squareup/franklin/api.pb'

export const logout = async ({ returnToSameUrl = true } = {}) => {
  await post<unknown, LogoutResponse>('/logout', {})

  window?.localStorage?.clear?.()
  window?.sessionStorage?.clear?.()

  if (returnToSameUrl) {
    window.location.href = `/login?return_to=${encodeURIComponent(window.location.pathname)}`
  } else {
    window.location.href = '/login'
  }
}
